import { faFileArchive, faFileText } from "@fortawesome/free-regular-svg-icons";
import {
  faBasketShopping,
  faBookBookmark,
  faDashboard,
  faLayerGroup,
  faStore,
  faUsers,
  faRotateLeft,
  faChartLine,
  faUpload,
  faCode,
  faCircleInfo,
  faCircleQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import useRole from "../hook/useRole";
import InfoIcon from "./InfoIcon";

const SidebarLink = ({ to, icon, children }) => (
  <NavLink
    className={({ isActive }) =>
      `sidebar-link btn btn-outline-secondary${isActive ? " active" : ""}`
    }
    to={to}
    end={to === "/"}
  >
    <InfoIcon size="lg" title={children} icon={icon} />
    <span className="sidebar-label">{children}</span>
  </NavLink>
);

const AdminSidebar = () => {
  const { hasrole } = useRole("rsosuperuser");

  return (
    <aside className="sidebar" aria-label="Admin navigation">
      <SidebarLink to="/" icon={faDashboard}>Dashboard</SidebarLink>
      <SidebarLink to="/admin/users" icon={faUsers}>Users</SidebarLink>
      <SidebarLink to="/admin/refund-requests" icon={faRotateLeft}>Refund requests</SidebarLink>
      <SidebarLink to="/admin/products" icon={faStore}>Products</SidebarLink>
      <SidebarLink to="/admin/producttypes" icon={faLayerGroup}>Types</SidebarLink>
      {hasrole && <SidebarLink to="/admin/logs" icon={faFileText}>Logs</SidebarLink>}
      {hasrole && <SidebarLink to="/admin/product-validity" icon={faCircleInfo}>Product validity</SidebarLink>}
      <SidebarLink to="/admin/files" icon={faFileArchive}>Files</SidebarLink>
      {hasrole && <SidebarLink to="/admin/querybuilder" icon={faCode}>QueryBuilder</SidebarLink>}
      {hasrole && <SidebarLink to="/admin/pdc" icon={faChartLine}>PDC</SidebarLink>}
      <SidebarLink to="/admin/instagram" icon={faUsers}>Instagram</SidebarLink>
      <SidebarLink to="/admin/uploadmanagement" icon={faUpload}>Uploads</SidebarLink>
      <SidebarLink to="/admin/faqs" icon={faCircleQuestion}>FAQs</SidebarLink>
    </aside>
  );
};

const UserSidebar = () => (
  <aside className="sidebar" aria-label="User navigation">
    <SidebarLink to="/" icon={faDashboard}>Dashboard</SidebarLink>
    <SidebarLink to="/orders" icon={faBasketShopping}>Orders</SidebarLink>
    <SidebarLink to="/products" icon={faStore}>Products</SidebarLink>
    <SidebarLink to="/favorites" icon={faBookBookmark}>Favorites</SidebarLink>
  </aside>
);

export default function Sidebar() {
  const isAdmin = useSelector((state) => state.user.isAdmin);
  return isAdmin ? <AdminSidebar /> : <UserSidebar />;
}
